import React from 'react';
import { SurveyQuestion } from './SurveyQuestion';

export const SurveyText = ({ option }) => {
    return (
        <React.Fragment>
            <SurveyQuestion option={option} />
        </React.Fragment>
    );
}